/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import axios from '../../../../../axios';
import API from 'actions/api';
import { buildFilterQuery } from '../utils';

const baseUrl = `${API}/dashboard`;

export const useListTransaction = (category) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState([
    {
      id: Date.now(),
      column: '',
      condition: '',
      value: '',
      additionalValues: { start: [], end: [] },
    },
  ]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false); // Initial load
  const [loadingMore, setLoadingMore] = useState(false); // Pagination load

  const fetchData = async (
    pageNumber = 1,
    isInitial = false,
    filtersParams = {},
  ) => {
    if (isInitial) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }

    try {
      const params = { category, page: pageNumber, page_size: 20, ...filtersParams };
      const res = await axios.get(`${baseUrl}/transactions`, { params });

      const newData = res.data.results || [];

      setData((prev) => {
        // If it's the first page, replace data instead of appending
        return pageNumber === 1 ? newData : [...prev, ...newData];
      });

      setHasMore(res.data.next !== null);
    } catch (error) {
      console.error('Fetch error:', error);
    } finally {
      if (isInitial) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  const applyFilters = async (newFilters) => {
    setFilters(newFilters);
    setData([]);
    setPage(1);
    try {
      const filterParams = buildFilterQuery(newFilters);

      await fetchData(page, page === 1, filterParams);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const filterParams = buildFilterQuery(filters);

    fetchData(page, page === 1, filterParams);
  }, [page]);

  const loadMoreIfPossible = () => {
    if (!loadingMore && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const refreshTransactions = () => {
    setData([]);
    setPage(1); // This triggers a re-fetch for page 1
  };

  return {
    data,
    loading, // show loader when page 1 is fetching
    loadingMore, // show loading spinner during pagination
    filters,
    refreshTransactions,
    lastItemRef: loadMoreIfPossible,
    applyFilters,
    setFilters,
  };
};

// import { useEffect, useCallback } from 'react';
// import { listIncomeTransaction } from 'actions';
// import { useDispatch, useSelector } from 'react-redux';

// export const useListTransaction = (category) => {
//   const dispatch = useDispatch();
//   const { income } = useSelector((state) => state.transaction);

//   useEffect(() => {
//     dispatch(listIncomeTransaction(category));
//   }, [category, dispatch]);

//   const refreshTransactions = useCallback(() => {
//     // Dispatch the action to fetch transactions
//     dispatch(listIncomeTransaction(category));
//   }, [dispatch, category]);

//   // let data = income.filter(({ transaction_item }) => {
//   //   return (
//   //     transaction_item[0]?.account_category === category ||
//   //     transaction_item[1]?.account_category === category
//   //   );
//   // });

//   let data = income;

//   return { data, refreshTransactions };
// };

// /* eslint-disable camelcase */
// import { useEffect, useCallback } from 'react';
// import { listIncomeTransaction } from 'actions';
// import { useDispatch, useSelector } from 'react-redux';

// export const useListTransaction = (category) => {
//   const dispatch = useDispatch();
//   const { income } = useSelector((state) => state.transaction);

//   useEffect(() => {
//     dispatch(listIncomeTransaction(category));
//   }, [category, dispatch]);

//   const refreshTransactions = useCallback(() => {
//     // Dispatch the action to fetch transactions
//     dispatch(listIncomeTransaction(category));
//   }, [dispatch, category]);

//   let data = income.filter(({ transaction_item }) => {
//     return (
//       transaction_item[0]?.account_category === category ||
//       transaction_item[1]?.account_category === category
//     );
//   });

//   return { data, refreshTransactions };
// };
